import { useEffect, useState } from 'react';
import FormWrapper from '../../../layout/FormWrapper/FormWrapper';
import FormLayout from '../../../layout/FormLayout/FormLayout';
import { StorageType } from '../../StorageForm';
import { Button, Icon } from '../../../../../components';
import { AssetManagerForm } from './StorageAssetManager';
import ServiceProviderSingle from './components/ServiceProviderSingle';
import { Icons } from '../../../../../components/Icon/Icon';

const StorageServiceProviders = ({ selectedData, generalInfo, setGeneralInfo, handleNextStep, handleClose }: any) => {
    const [additionalRoles, setAdditionalRoles] = useState<any[]>([]);
    const [showCreateForm, setShowCreateForm] = useState<undefined | null | AssetManagerForm>();

    const [data, setData] = useState<any[]>(selectedData ? [...selectedData] : [{}]);

    const [selectionsValid, setSelectionsValid] = useState<any>(false);

    useEffect(() => {
        setSelectionsValid(!data.some((item) => !item.role?.value));
    }, [data]);

    const handleAddItem = (e: any) => {
        setData([...data, {}]);

        setTimeout(() => {
            e.target.closest('#selectionBox').scrollTop = e.target.closest('#selectionBoxInner').scrollHeight;
        });
    };

    const handleRemoveItem = (index: number) => () => {
        const tmp = [...data];
        tmp.splice(index, 1);
        setData(tmp);
    };

    const handleShowCreateForm = (type: AssetManagerForm) => () => {
        setShowCreateForm(type);
    };

    const handleItemUpdate = (index: number) => (item: any) => {
        const tmp = [...data];
        tmp[index] = item;
        setData(tmp);
    };

    return (
        <FormWrapper>
            <FormLayout
                title={'Services providers'}
                description={'Please fill in information about service providers.'}
                footerAdditionalGrid={true}
                footerAdditional={
                    <Button
                        secondary={true}
                        outlined={true}
                        type={'button'}
                        before={<Icon icon={Icons.add} />}
                        onClick={handleAddItem}
                        fullWidth={true}
                        disabled={!selectionsValid}
                        align={'left'}
                    >
                        Add line
                    </Button>
                }
                footerMain={<Button form={'mainForm'}>Next</Button>}
                handleClose={handleClose}
                handlePrevStep={handleNextStep(data, StorageType.AssetManager)}
            >
                <form id={'mainForm'} onSubmit={handleNextStep(data, StorageType.Other)}>
                    {data.map((item: any, index: number) => (
                        <ServiceProviderSingle
                            key={index}
                            selectedData={item}
                            generalInfo={generalInfo}
                            setGeneralInfo={setGeneralInfo}
                            handleRemoveItem={handleRemoveItem(index)}
                            handleShowCreateForm={handleShowCreateForm}
                            onUpdate={handleItemUpdate(index)}
                            additionalRoles={additionalRoles}
                        />
                    ))}
                </form>
            </FormLayout>
        </FormWrapper>
    );
};

export default StorageServiceProviders;
